export default __webpack_public_path__ + "static/media/4.24c6ddc3.jpg";